import { render, staticRenderFns } from "./CustomBriLifeLotteryDialog.vue?vue&type=template&id=92c3ec3c&scoped=true&"
import script from "./CustomBriLifeLotteryDialog.vue?vue&type=script&lang=js&"
export * from "./CustomBriLifeLotteryDialog.vue?vue&type=script&lang=js&"
import style0 from "./CustomBriLifeLotteryDialog.vue?vue&type=style&index=0&id=92c3ec3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c3ec3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VCol,VDialog,VRow})
